import React, { useEffect, useState } from 'react';
import useHash from 'hooks/useHash';
import { STIcon } from 'components/Brand/Icons/STIcon';
import HyperLink from 'components/Core/HyperLink';
import Carousel from 'components/Core/Carousel';
import checkIsHeadingInHash from 'utils/checkIsHeadingInHash';
import { CarouselContainer, SectionContainer } from './styles';

const CommercialFeatureList = ({ title, items = [], slidesToShow, ...otherProps }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const headerItems = items.map(({ title }) => title);
  const [hash] = useHash();

  useEffect(() => {
    headerItems.forEach((item, index) => {
      if (checkIsHeadingInHash(hash, item)) {
        setActiveIndex(index);
      }
    });
  }, [hash]);

  return (
    <CarouselContainer {...otherProps}>
      <Carousel
        heading={title}
        versionStyling="V5"
        headerItems={headerItems}
        slidesToShow={slidesToShow}
        activeIndex={activeIndex}
      >
        {items.map(({ title, link, items }, index) => (
          <SectionContainer
            className={activeIndex === index ? 'active' : 'inactive'}
            carousel
            key={`carousel-${index}`}
            id={title?.replace(/\s+/g, '-').toLowerCase()}
          >
            <h4>{link ? <HyperLink href={link}>{title}</HyperLink> : title}</h4>
            {items?.map(({ title, link, items }, index) => (
              <HyperLink href={link} className={!link ? 'nolink' : ''} key={`item-${index}`}>
                <div>
                  <p>
                    {title}
                    {items && (
                      <ul>
                        {items.map(({ title }) => (
                          <li>{title}</li>
                        ))}
                      </ul>
                    )}
                  </p>
                  <div>{link && <STIcon type="infolink" />}</div>
                </div>
              </HyperLink>
            ))}
          </SectionContainer>
        ))}
      </Carousel>
    </CarouselContainer>
  );
};

export default CommercialFeatureList;
